import GamificationBar from "GamificationBar/GamificationBar"
import { StyledGamificationBar } from "GamificationBar/styled"

export { GamificationBar, StyledGamificationBar }
